import type { ProductKey } from "@merge-api/merge-javascript-shared";
import { fetchWithAuth } from "../../../../api-client/APIClient";
import { User } from "../../../../models/Entities";

const saveDefaultProduct = (product: ProductKey): Promise<User> =>
  new Promise((resolve, reject) => {
    fetchWithAuth({
      path: "/users/me",
      method: "PATCH",
      body: { default_product: product },
      onResponse: (data: { user: User }) => resolve(data.user),
      onError: reject,
    });
  });

export default saveDefaultProduct;
